
import { Component, Vue } from 'vue-property-decorator'
import PublicTable from '@/components/PublicTable/PublicTable.vue'
import PublicTableView from '@/components/PublicTable/PublicTableView'
import { ICol } from '@/components/PublicTable/PublicTable'
import CreateUser from '@/components/Dialog/CreateUser.vue'
import api from '../../api'
import { UserModule } from '../../store/modules/user'
@Component({
  components: {
    PublicTable,
    CreateUser,
  },
})
export default class UserList extends PublicTableView {
  protected columns: ICol[] = [
    { label: '用户名', prop: 'name' },
    { label: '姓名', prop: 'nickName' },
    { label: '权限', prop: 'role', sortable: true, type: 'custom' },
    { label: '管理区域', prop: 'pos', type: 'custom' },
    { label: '手机号', prop: 'phone' },
    { label: '用户状态', prop: '_enable' },
  ]
  protected input:any=''
  protected queryParams = {
    arg1: UserModule.orgInfo.orgId,

  }
  public mounted() {
    this.onQuery(1)
  }
  protected queryMethod = api.getUserList

  protected processData(data: any) {
    // console.log('-------' + JSON.stringify(data))
    const { totalSize = 0, content = [] } = data || {}
    this.pageData.pageCount = totalSize
    content.forEach((item: any) => {
      item._enable = Number(item.enable) === 0 ? '异常' : '正常'
    })
    return content
  }

  private change() {
    if (this.input.length === 0) {
      this.queryParams = {
        arg1: UserModule.orgInfo.orgId,
      }
      this.onQuery({ pageNum: 1, isUseCache: false })
    } else {
      console.log(this.input)
      this.queryParams['userName'] = this.input
      this.onQuery({ pageNum: 1, isUseCache: false })
    }
  }

  private createUser() {
    (this.$refs.createUser as CreateUser).show()
  }

  private modifyUser(row: any) {
    (this.$refs.createUser as CreateUser).show(row)
  }

  private deleteUser(row: any) {
    this.$confirm('删除此用户, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      api.deleteUser({ name: row.name }).then(() => {
        this.$message.success('删除成功')
        this.onQuery({ pageNum: 1, isUseCache: false })
      })
    }).catch(() => {})
  }
}
